<template>
    <div class="flex flex-wrap gap-2">
        <div v-if="isGlobalNews" class="bg-black text-white capitalize font-normal py-0.5 px-1 box-border rounded-[6px] text-body-7">
            Global News
        </div>
        <div
                v-for="tag in filteredTags"
                :key="tag"
                class="capitalize font-normal py-0.5 px-1 box-border rounded-[6px] text-body-7 text-primary-1"
                :style="{background: getAuxiliaryColor}"
        >
            {{tag}}
        </div>
        <div v-if="tags.length > 4"
             class="capitalize font-light py-0.5 px-1 box-border rounded-[6px] text-body-7 text-primary-1"
             :style="{background: getAuxiliaryColor}"
        >
            + {{ tags.length - 4 }}
        </div>
    </div>
</template>
<script setup>
import {computed} from "vue";
import {useTheme} from "@/stores/ThemeStore";

const {getAuxiliaryColor} = useTheme();

const props = defineProps({
    tags: {
        type: Array
    }
});

const isGlobalNews = computed(() => {
    return props.tags.some(tag => tag === "Global News");
});

const filteredTags = computed(() => {
    let auxTags = [...props.tags];

    if(isGlobalNews.value) {
        auxTags = auxTags.filter(tag => tag !== "Global News");
    }

    if(props.tags.length <= 4) {
        return auxTags;
    }

    return auxTags.slice(0, 5);
});
</script>
